import Button from '@components/atoms/Button';
import {SystemPlanDropdownWrapper} from './SystemPlanDropdown.styles';
import {useState} from 'react';
import ViewSystemPlansModal from '@organisms/modals/ViewSystemPlansModal';
import {EUserRoles, EUserScopedRoles} from '@constants/usersRoles';

export const SystemPlanDropdown = ({
  onAddSystemPlan,
  role,
  scopedRole,
}: {
  onAddSystemPlan: () => void;
  role?: number;
  scopedRole?: number;
}) => {
  const [showViewPlans, setShowViewPlans] = useState(false);
  return (
    <SystemPlanDropdownWrapper>
      {(role !== EUserRoles.BASE_USER ||
        (scopedRole && scopedRole !== EUserScopedRoles.VIEWER)) && (
        <Button title="Добавить план покрытия" variant="text" onClick={onAddSystemPlan} />
      )}
      <Button
        title="Просмотреть имеющиеся планы"
        variant="text"
        onClick={() => setShowViewPlans(true)}
      />
      <ViewSystemPlansModal
        isOpened={showViewPlans}
        onCloseRequest={() => setShowViewPlans(false)}
      />
    </SystemPlanDropdownWrapper>
  );
};
